import { render, staticRenderFns } from "./withdraw-config.vue?vue&type=template&id=60dc80b8&scoped=true"
import script from "./withdraw-config.vue?vue&type=script&lang=js"
export * from "./withdraw-config.vue?vue&type=script&lang=js"
import style0 from "./withdraw-config.vue?vue&type=style&index=0&id=60dc80b8&prod&scoped=true&lang=css"
import style1 from "./withdraw-config.vue?vue&type=style&index=1&id=60dc80b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc80b8",
  null
  
)

export default component.exports